import { MaterialReactTable } from "material-react-table";
import React from "react";

import { ROOM_CONFIGS_NAMES, ROOM_NAMES } from "@/lib/constants";
import { AccountIdMappingTable } from "@/module/room-configs-module/account-id-mapping-table-module/account-id-mapping-table";
import AvatarConfigTable from "@/module/room-configs-module/avatar-config-table";
import CmsAggregatorConfigTable from "@/module/room-configs-module/cms-aggregator-config-table";
import CommonConfigTable from "@/module/room-configs-module/common-config-table";
import GameGroupConfigTable from "@/module/room-configs-module/game-group-config-table";
import ManagerConfigTable from "@/module/room-configs-module/manager-config-module/manager-config-table";
import NameConfigTable from "@/module/room-configs-module/name-config-table";
import PlayerGroupConfigTable from "@/module/room-configs-module/player-group-config-table";
import ProxyConfigTable from "@/module/room-configs-module/proxy-config-table";
import ScheduleConfigTable from "@/module/room-configs-module/schedule-config-table";
import UsernameConfigTable from "@/module/room-configs-module/username-config-table/username-config-table";
import { AiconGameGroupTable } from "@/module/service-configs-module/aicon-game-group-module/aicon-game-group-table";
import InsuranceConfigTable from "@/module/room-configs-module/insurance-config-table/insurance-config-table";
import BehaviourConfigTable from "@/module/room-configs-module/behaviour-config-module/behaviour-config-table";
import TimingConfigTable from "@/module/room-configs-module/timing-config-module/timing-config-table";
import WhitelistConfigTable from "@/module/room-configs-module/whitelist-config-module/whitelist-config-table";
import { ClubIdMappingTable } from "@/module/room-configs-module/clubs-mapping-table-module/club-id-mapping-table";

const MainTable = ({ room, cfg }: { room: string; cfg: string }) => {
  if (!room || !cfg) return <MaterialReactTable columns={[]} data={[]} />;

  switch (cfg) {
    case ROOM_CONFIGS_NAMES.PROXY:
      return <ProxyConfigTable room={room} />;
    case ROOM_CONFIGS_NAMES.GAME_GROUP:
      if (room === ROOM_NAMES.AICON) {
        return <AiconGameGroupTable room={room} />;
      }
      return <GameGroupConfigTable room={room} />;
    case ROOM_CONFIGS_NAMES.NICKNAME:
      return <NameConfigTable room={room} />;
    case ROOM_CONFIGS_NAMES.AVATAR:
      return <AvatarConfigTable room={room} />;
    case ROOM_CONFIGS_NAMES.PLAYER_GROUP:
      return <PlayerGroupConfigTable room={room} />;
    case ROOM_CONFIGS_NAMES.SCHEDULE:
      return <ScheduleConfigTable room={room} />;
    case ROOM_CONFIGS_NAMES.CMS_AGGREGATOR:
      return <CmsAggregatorConfigTable room={room} />;
    case ROOM_CONFIGS_NAMES.USERNAME:
      return <UsernameConfigTable room={room} />;
    case ROOM_CONFIGS_NAMES.MANAGER:
      return <ManagerConfigTable room={room} />;
    case ROOM_CONFIGS_NAMES.ACCOUNT_ID_MAPPING:
      return <AccountIdMappingTable />;
    case ROOM_CONFIGS_NAMES.CLUB_ID_MAPPING:
      return <ClubIdMappingTable />;
    case ROOM_CONFIGS_NAMES.INSURANCE:
      return <InsuranceConfigTable room={room} />;
    /*case ROOM_CONFIGS_NAMES.BEHAVIOUR:
      return <BehaviourConfigTable room={room} />;*/
    case ROOM_CONFIGS_NAMES.TIMING:
      return <TimingConfigTable room={room} />;
    case ROOM_CONFIGS_NAMES.WHITELIST:
      return <WhitelistConfigTable room={room} />;


    default:
      return <CommonConfigTable room={room} cfg={cfg} />;
  }
};

export default MainTable;
